function Question(text,callback) {
  this.name='question';
  this.text=text;
   this.callback= callback;
}

export {Question};
